import React from "react";
import { render } from "react-dom";
import Mdhtml from '../content/text1.mdx';
import { moduleEvents, problemSetEvents, breakDayEvents, problemSetsAssigned, problemSetsDue, examEvents, moduleStartDates } from '../content/calendarinfo'
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';


//document.querySelector(".bodytext").innerHTML = mdhtml;

const body = document.querySelector(".bodytext")
render(<Mdhtml />, body);

const problemSetsHTML = problemSetsAssigned.reduce((acc, curr, i) => (acc+`
			<tr>
	            <td>${i+1}</td>
	            <td>${curr.slice(5)}</td>
	            <td>${problemSetsDue[i].slice(5,10)}, 5:00 PM</td>
	            <td>${10+i*5}%</td>
        	</tr>`
        	), "")


document.querySelector(".duedates").innerHTML = `
    <thead>
        <tr>
            <th>Problem Set</th>
            <th>Available</th>
            <th>Due</th>
            <th>% of Final Grade</th>
        </tr>
    </thead>
    <tbody>
        ${problemSetsHTML}
    </tbody>
`


const calendarEl = document.getElementById('calendar');

const calendar = new Calendar(calendarEl, {
	    plugins: [ dayGridPlugin ],
		eventSources: [{events: moduleEvents, display: 'background', backgroundColor: "#e6e6e6"},
						{events: problemSetEvents, color: '#de863a'},
						{events: breakDayEvents, display: 'background', backgroundColor: 'lightblue'},
						{events: examEvents, display: 'background', backgroundColor: 'lightpink'},
						//{events: moduleEndDates, display: 'list-item', color: "#de863a"}
                        {events: moduleStartDates, display: 'list-item', color: "#de863a"}
						]
});

calendar.render();

var styleEl = document.createElement('style'), styleSheet;
            document.head.appendChild(styleEl);
            styleSheet = styleEl.sheet;
            styleSheet.insertRule(".fc-daygrid-dot-event {white-space: normal}", 0);
            styleSheet.insertRule(".fc .fc-bg-event {opacity: 0.5}", 0);
            styleSheet.insertRule(".fc-event-time {opacity: 0}", 0);


